<mz-dialog #manageTagsModal [uid]="uid" [title]="l('ManageTags')" [canSubmit]="form.valid"
    [submitButtonLabel]="l('Save')" (beforeSubmit)="beforeSubmit($event)">
    <p>{{ l('ManageTagsInfoText', nonUniformTags?.join(', ')) }}</p>
    <form [formGroup]="form" (ngSubmit)="modal.submit()" autocomplete="off">
        <div class="form-group">
            <mazars-tags *ngIf="!referenceDataLoading" uid="'manage_tags'" placeholder="{{ l('Tags') }}"
                [availableTags]="availableTags" formControlName="tags"></mazars-tags>
        </div>
    </form>
</mz-dialog>